(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1808],{

/***/ 89529:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/support/inquiry/write",
      function () {
        return __webpack_require__(69760);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 94141:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ AlertModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _styles_colors__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(32317);
/* harmony import */ var _styles_z_indexes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9227);
/* harmony import */ var baseui_modal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85438);
/* harmony import */ var baseui_modal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71203);
/* harmony import */ var baseui_modal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51983);
/* harmony import */ var styletron_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54511);
/* harmony import */ var _base_button__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(11485);
/* harmony import */ var _base_typography__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(53321);
/* harmony import */ var _base_typography__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(88292);
/* harmony import */ var _hooks_use_modal_scroll_bar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1174);









var AlertModal = function(param) {
    var onClose = param.onClose, isOpen = param.isOpen, title = param.title, description = param.description, _label = param.label, label = _label === void 0 ? "확인" : _label, _type = param.type, type = _type === void 0 ? "warning" : _type;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,styletron_react__WEBPACK_IMPORTED_MODULE_2__/* .useStyletron */ .hQ)(), 1), css = ref[0];
    (0,_hooks_use_modal_scroll_bar__WEBPACK_IMPORTED_MODULE_3__/* .useModalScrollBar */ .V)(isOpen);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(baseui_modal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        onClose: onClose,
        isOpen: isOpen,
        closeable: true,
        animate: true,
        size: baseui_modal__WEBPACK_IMPORTED_MODULE_5__/* .SIZE["default"] */ .NO["default"],
        role: baseui_modal__WEBPACK_IMPORTED_MODULE_5__/* .ROLE.dialog */ .HB.dialog,
        autoFocus: false,
        overrides: {
            Root: {
                style: {
                    zIndex: _styles_z_indexes__WEBPACK_IMPORTED_MODULE_6__/* .zIndexes.alretModal */ .U.alretModal
                }
            }
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(baseui_modal__WEBPACK_IMPORTED_MODULE_7__/* .ModalHeader */ .xB, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_base_typography__WEBPACK_IMPORTED_MODULE_8__/* .HeadingS */ .HR, {
                    whiteSpace: "pre-wrap",
                    minHeight: "32px",
                    children: title
                })
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(baseui_modal__WEBPACK_IMPORTED_MODULE_7__/* .ModalBody */ .fe, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_base_typography__WEBPACK_IMPORTED_MODULE_9__/* .ParagraphM */ .Sl, {
                    color: _styles_colors__WEBPACK_IMPORTED_MODULE_10__/* .colors.gray500 */ .O.gray500,
                    whiteSpace: "pre-wrap",
                    minHeight: "16px",
                    children: description
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(baseui_modal__WEBPACK_IMPORTED_MODULE_7__/* .ModalFooter */ .mz, {
                className: css({
                    display: "flex",
                    gap: "16px",
                    justifyContent: "flex-end",
                    marginBottom: "12px"
                }),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_base_button__WEBPACK_IMPORTED_MODULE_11__/* .BaseButton */ .Y, {
                    $type: "secondary",
                    fluid: true,
                    onClick: onClose,
                    overrides: {
                        BaseButton: {
                            style: {
                                backgroundColor: type === "warning" ? _styles_colors__WEBPACK_IMPORTED_MODULE_10__/* .colors.red50 */ .O.red50 : _styles_colors__WEBPACK_IMPORTED_MODULE_10__/* .colors.blue50 */ .O.blue50,
                                color: type === "warning" ? _styles_colors__WEBPACK_IMPORTED_MODULE_10__/* .colors.red400 */ .O.red400 : _styles_colors__WEBPACK_IMPORTED_MODULE_10__/* .colors.blue400 */ .O.blue400,
                                ":hover": {
                                    backgroundColor: type === "warning" ? _styles_colors__WEBPACK_IMPORTED_MODULE_10__/* .colors.red100 */ .O.red100 : _styles_colors__WEBPACK_IMPORTED_MODULE_10__/* .colors.blue100 */ .O.blue100,
                                    color: type === "warning" ? _styles_colors__WEBPACK_IMPORTED_MODULE_10__/* .colors.red400 */ .O.red400 : _styles_colors__WEBPACK_IMPORTED_MODULE_10__/* .colors.blue400 */ .O.blue400
                                }
                            }
                        }
                    },
                    children: label
                })
            })
        ]
    });
};


/***/ }),

/***/ 54950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ ConfirmModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _styles_colors__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(32317);
/* harmony import */ var _styles_z_indexes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9227);
/* harmony import */ var baseui_modal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85438);
/* harmony import */ var baseui_modal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71203);
/* harmony import */ var baseui_modal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51983);
/* harmony import */ var styletron_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54511);
/* harmony import */ var _base_button__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(11485);
/* harmony import */ var _base_typography__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(53321);
/* harmony import */ var _base_typography__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(88292);
/* harmony import */ var _hooks_use_modal_scroll_bar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1174);









var ConfirmModal = function(param) {
    var onConfirm = param.onConfirm, onClose = param.onClose, isOpen = param.isOpen, isLoading = param.isLoading, title = param.title, description = param.description, _cancelLabel = param.cancelLabel, cancelLabel = _cancelLabel === void 0 ? "취소" : _cancelLabel, _confirmLabel = param.confirmLabel, confirmLabel = _confirmLabel === void 0 ? "확인" : _confirmLabel, _type = param.type, type = _type === void 0 ? "default" : _type, _fluid = param.fluid, fluid = _fluid === void 0 ? true : _fluid;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,styletron_react__WEBPACK_IMPORTED_MODULE_2__/* .useStyletron */ .hQ)(), 1), css = ref[0];
    (0,_hooks_use_modal_scroll_bar__WEBPACK_IMPORTED_MODULE_3__/* .useModalScrollBar */ .V)(isOpen);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(baseui_modal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        onClose: onClose,
        isOpen: isOpen,
        closeable: true,
        animate: true,
        autoFocus: false,
        size: baseui_modal__WEBPACK_IMPORTED_MODULE_5__/* .SIZE["default"] */ .NO["default"],
        role: baseui_modal__WEBPACK_IMPORTED_MODULE_5__/* .ROLE.dialog */ .HB.dialog,
        overrides: {
            Root: {
                style: {
                    zIndex: _styles_z_indexes__WEBPACK_IMPORTED_MODULE_6__/* .zIndexes.confirmModal */ .U.confirmModal
                }
            }
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(baseui_modal__WEBPACK_IMPORTED_MODULE_7__/* .ModalHeader */ .xB, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_base_typography__WEBPACK_IMPORTED_MODULE_8__/* .HeadingS */ .HR, {
                    minHeight: "32px",
                    children: title
                })
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(baseui_modal__WEBPACK_IMPORTED_MODULE_7__/* .ModalBody */ .fe, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_base_typography__WEBPACK_IMPORTED_MODULE_9__/* .ParagraphM */ .Sl, {
                    color: _styles_colors__WEBPACK_IMPORTED_MODULE_10__/* .colors.gray500 */ .O.gray500,
                    whiteSpace: "pre-wrap",
                    minHeight: "16px",
                    children: description
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(baseui_modal__WEBPACK_IMPORTED_MODULE_7__/* .ModalFooter */ .mz, {
                className: css({
                    display: "flex",
                    gap: "16px",
                    justifyContent: "flex-end",
                    marginBottom: "12px"
                }),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_base_button__WEBPACK_IMPORTED_MODULE_11__/* .BaseButton */ .Y, {
                        $type: type === "danger" ? "tertiary" : "secondary",
                        fluid: fluid,
                        onClick: onClose,
                        overrides: type === "danger" ? {
                            BaseButton: {
                                style: {
                                    minWidth: "120px"
                                }
                            }
                        } : {},
                        children: cancelLabel
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_base_button__WEBPACK_IMPORTED_MODULE_11__/* .BaseButton */ .Y, {
                        fluid: fluid,
                        onClick: onConfirm,
                        isLoading: isLoading,
                        overrides: type === "danger" ? {
                            BaseButton: {
                                style: {
                                    minWidth: "120px",
                                    color: _styles_colors__WEBPACK_IMPORTED_MODULE_10__/* .colors.white */ .O.white,
                                    backgroundColor: _styles_colors__WEBPACK_IMPORTED_MODULE_10__/* .colors.red400 */ .O.red400,
                                    ":hover": {
                                        color: _styles_colors__WEBPACK_IMPORTED_MODULE_10__/* .colors.white */ .O.white,
                                        backgroundColor: _styles_colors__WEBPACK_IMPORTED_MODULE_10__/* .colors.red500 */ .O.red500
                                    }
                                }
                            }
                        } : {},
                        children: confirmLabel
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 1174:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ useModalScrollBar; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useModalScrollBar = function(isOpen) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (document.documentElement.scrollHeight > document.documentElement.clientHeight) {
            if (isOpen) {
                document.body.classList.add("has-modal");
            } else {
                setTimeout(function() {
                    document.body.classList.remove("has-modal");
                }, 100);
            }
        }
        return function() {
            document.body.classList.remove("has-modal");
        };
    }, [
        isOpen
    ]);
};


/***/ }),

/***/ 21052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ ModalStateContainer; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var ModalStateContainer = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isConfirmationOpen = ref[0], setIsConfirmationOpen = ref[1];
    var toggleConfirm = function() {
        var open = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !isConfirmationOpen, cb = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {};
        setIsConfirmationOpen(open);
        cb();
    };
    return children({
        isConfirmationOpen: isConfirmationOpen,
        toggleConfirm: toggleConfirm
    });
};


/***/ }),

/***/ 23780:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ BaseTextarea; }
/* harmony export */ });
/* unused harmony export Hint */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _styles_colors__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(32317);
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67265);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var baseui_textarea__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85989);
/* harmony import */ var _base_input_use_input_overrides__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56457);
/* harmony import */ var _base_typography__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(67408);
/* harmony import */ var _hooks_use_overrides__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(58817);
/* harmony import */ var _icon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(32079);













var BaseTextarea = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) {
    var overrides = _param.overrides, leading = _param.leading, trailing = _param.trailing, action = _param.action, onAction = _param.onAction, error = _param.error, positive = _param.positive, disabled = _param.disabled, spaceTop = _param.spaceTop, spaceBottom = _param.spaceBottom, label = _param.label, _size = _param.size, size = _size === void 0 ? "l" : _size, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "overrides",
        "leading",
        "trailing",
        "action",
        "onAction",
        "error",
        "positive",
        "disabled",
        "spaceTop",
        "spaceBottom",
        "label",
        "size"
    ]);
    var inputOverrides = (0,_base_input_use_input_overrides__WEBPACK_IMPORTED_MODULE_3__/* .useInputOverrides */ .y)({
        spaceTop: spaceTop,
        spaceBottom: spaceBottom,
        size: size,
        label: label
    }).inputOverrides;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(baseui_textarea__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                clearable: true,
                overrides: (0,_hooks_use_overrides__WEBPACK_IMPORTED_MODULE_7__/* .useOverrides */ .Q)((0,_hooks_use_overrides__WEBPACK_IMPORTED_MODULE_7__/* .useOverrides */ .Q)(inputOverrides, {
                    Input: {
                        style: {
                            maxHeight: "800px",
                            minHeight: "240px",
                            minWidth: "calc(100% - 16px)",
                            width: "100%",
                            resize: "vertical",
                            margin: "0px 0px 2px"
                        }
                    },
                    InputContainer: {
                        style: {
                            maxWidth: "100%",
                            minWidth: "100%",
                            width: "min-content"
                        }
                    }
                }), overrides),
                error: Boolean(error),
                positive: Boolean(positive),
                disabled: disabled
            }, props), {
                ref: ref
            })),
            !disabled && error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Hint, {
                msg: error,
                type: "error"
            }),
            !disabled && positive && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Hint, {
                msg: positive,
                type: "positive"
            })
        ]
    });
});
var Hint = function(param) {
    var msg = param.msg, type = param.type;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,baseui__WEBPACK_IMPORTED_MODULE_9__/* .useStyletron */ .hQ)(), 1), css = ref[0];
    var style = {
        error: {
            color: _styles_colors__WEBPACK_IMPORTED_MODULE_10__/* .colors.red400 */ .O.red400,
            icon: "Spam2Line"
        },
        positive: {
            color: _styles_colors__WEBPACK_IMPORTED_MODULE_10__/* .colors.green400 */ .O.green400,
            icon: "CheckDoubleFill"
        }
    }[type];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
        className: css({
            display: "inline-flex",
            alignItems: "center",
            marginTop: "4px"
        }),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon__WEBPACK_IMPORTED_MODULE_11__/* .Icon */ .J, {
                type: style.icon,
                size: 16,
                color: style.color
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_base_typography__WEBPACK_IMPORTED_MODULE_12__/* .LabelS */ .ew, {
                color: style.color,
                marginLeft: "4px",
                children: msg
            })
        ]
    });
};


/***/ }),

/***/ 26022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ InfoBoxWithIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _styles_colors__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(32317);
/* harmony import */ var _styles_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45500);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43281);
/* harmony import */ var styletron_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54511);
/* harmony import */ var _base_block__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94306);
/* harmony import */ var _icon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(32079);










var InfoBoxWithIcon = function(param) {
    var children = param.children, icon = param.icon;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,styletron_react__WEBPACK_IMPORTED_MODULE_2__/* .useStyletron */ .hQ)(), 1), css = ref[0];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_base_block__WEBPACK_IMPORTED_MODULE_3__/* .BaseBlock */ .v, {
        className: css((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            width: "100%"
        }, (0,polished__WEBPACK_IMPORTED_MODULE_6__/* .padding */ .o3)("20px"), (0,_styles_utils__WEBPACK_IMPORTED_MODULE_7__/* .borderRadius */ .E0)(16), (0,_styles_utils__WEBPACK_IMPORTED_MODULE_7__/* .border */ .Cg)(_styles_colors__WEBPACK_IMPORTED_MODULE_8__/* .colors.gray200 */ .O.gray200)), {
            display: "flex",
            flexDirection: "column",
            boxSizing: "border-box"
        })),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon__WEBPACK_IMPORTED_MODULE_9__/* .Icon */ .J, {
                type: icon,
                size: 32,
                color: _styles_colors__WEBPACK_IMPORTED_MODULE_8__/* .colors.gray700 */ .O.gray700
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_base_block__WEBPACK_IMPORTED_MODULE_3__/* .BaseBlock */ .v, {
                marginTop: "12px",
                children: children
            })
        ]
    });
};


/***/ }),

/***/ 73553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ formOptions; }
/* harmony export */ });
/* unused harmony export EMAIL_ERROR_MSG */
var EMAIL_ERROR_MSG = "올바른 이메일을 입력해주세요.";
var PASSWORD_ERROR_MSG = "올바른 비밀번호를 입력해주세요.";
var VERIFICATION_CODE_ERROR_MSG = "인증번호가 올바른지 확인해주세요.";
var formOptions = {
    EMAIL: {
        required: EMAIL_ERROR_MSG,
        pattern: {
            value: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g,
            message: EMAIL_ERROR_MSG
        },
        minLength: {
            value: 6,
            message: EMAIL_ERROR_MSG
        },
        maxLength: {
            value: 24,
            message: EMAIL_ERROR_MSG
        }
    },
    PASSWORD: {
        required: PASSWORD_ERROR_MSG,
        maxLength: {
            value: 20,
            message: PASSWORD_ERROR_MSG
        }
    },
    PHONE_NUMBER: {
        pattern: {
            value: /^01(?:0|1|[6-9])(?:\d{3}|\d{4})\d{4}$/,
            message: "올바른 휴대폰 번호를 입력해주세요."
        }
    },
    VERIFICATION_CODE: {
        pattern: {
            value: /^[0-9]*$/,
            message: VERIFICATION_CODE_ERROR_MSG
        },
        maxLength: {
            value: 6,
            message: VERIFICATION_CODE_ERROR_MSG
        }
    },
    NAME: {
        required: "이름을 입력해주세요",
        minLength: {
            value: 2,
            message: "이름은 2자 이상으로 입력해주세요"
        },
        maxLength: {
            value: 10,
            message: "이름은 10자 이하로 입력해주세요"
        }
    },
    NICKNAME: {
        required: "닉네임을 입력해주세요",
        minLength: {
            value: 3,
            message: "닉네임은 3자 이상 입력해주세요"
        },
        maxLength: {
            value: 10,
            message: "닉네임은 10자 이하로 입력해주세요"
        }
    },
    TITLE: {
        required: "제목을 입력해주세요",
        maxLength: {
            value: 40,
            message: "제목은 40자 이하로 입력해주세요"
        }
    }
};


/***/ }),

/***/ 93149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ fileSize; }
/* harmony export */ });
var fileSize = function(size) {
    var i = Math.floor(Math.log(size) / Math.log(1024));
    return Math.floor(size / Math.pow(1024, i)) + [
        "B",
        "kB",
        "MB",
        "GB",
        "TB"
    ][i];
};


/***/ }),

/***/ 33510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ useFileUploaderWithForm; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87536);
/* harmony import */ var lodash_compact__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39693);
/* harmony import */ var lodash_compact__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_compact__WEBPACK_IMPORTED_MODULE_1__);



var useFileUploaderWithForm = function() {
    var maxFileCount = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 5;
    var ref = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_2__/* .useFormContext */ .Gc)(), setError = ref.setError, setValue = ref.setValue, watch = ref.watch, clearErrors = ref.clearErrors;
    var files = watch("files");
    var onDrop = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(acceptedFiles) {
        clearErrors("files");
        if (files.length === 0) {
            if (acceptedFiles.length > maxFileCount) {
                return setError("files", {
                    message: "파일은 최대 ".concat(maxFileCount, "개까지 업로드할 수 있습니다")
                });
            }
            return setValue("files", acceptedFiles);
        }
        var newFiles = lodash_compact__WEBPACK_IMPORTED_MODULE_1___default()(acceptedFiles.map(function(file) {
            var exists = files.map(function(file) {
                return file.name;
            }).includes(file.name);
            if (!exists) return file;
            return setError("warning", {
                message: "중복된 파일을 제외하고 첨부되었습니다."
            });
        }));
        if (newFiles && newFiles.length > 0) {
            var newValue = files.concat(newFiles);
            if (newValue.length > maxFileCount) {
                return setError("files", {
                    message: "파일은 최대 ".concat(maxFileCount, "개까지 업로드할 수 있습니다")
                });
            }
            setValue("files", newValue);
        }
    }, [
        clearErrors,
        files,
        maxFileCount,
        setError,
        setValue
    ]);
    var onDropRejected = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        setError("files", {
            message: "20MB 이하의 파일만 업로드할 수 있습니다."
        });
    }, [
        setError
    ]);
    var onRemoveFile = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(fileName) {
        var filtered = files.filter(function(file) {
            return file.name !== fileName;
        });
        setValue("files", filtered);
    }, [
        files,
        setValue
    ]);
    return {
        onRemoveFile: onRemoveFile,
        onDrop: onDrop,
        onDropRejected: onDropRejected
    };
};


/***/ }),

/***/ 69760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ write; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(51351);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/layouts/basic-layout.tsx + 1 modules
var basic_layout = __webpack_require__(99407);
// EXTERNAL MODULE: ./components/base-block/base-block.tsx
var base_block = __webpack_require__(94306);
// EXTERNAL MODULE: ./components/base-button/base-button.tsx + 1 modules
var base_button = __webpack_require__(11485);
// EXTERNAL MODULE: ./components/base-cell/base-cell.tsx
var base_cell = __webpack_require__(84525);
// EXTERNAL MODULE: ./components/base-grid/base-grid.tsx
var base_grid = __webpack_require__(83825);
// EXTERNAL MODULE: ./components/base-input/input-with-label.tsx
var input_with_label = __webpack_require__(35307);
// EXTERNAL MODULE: ./components/base-modal/modal-state-container.tsx
var modal_state_container = __webpack_require__(21052);
// EXTERNAL MODULE: ./components/base-modal/confirm-modal.tsx
var confirm_modal = __webpack_require__(54950);
// EXTERNAL MODULE: ./components/base-modal/alert-modal.tsx
var alert_modal = __webpack_require__(94141);
// EXTERNAL MODULE: ./components/base-textarea/base-textarea.tsx
var base_textarea = __webpack_require__(23780);
// EXTERNAL MODULE: ./components/base-typography/heading.tsx
var heading = __webpack_require__(53321);
// EXTERNAL MODULE: ./components/base-typography/label.tsx
var label = __webpack_require__(67408);
// EXTERNAL MODULE: ./components/base-typography/paragraph.tsx
var paragraph = __webpack_require__(88292);
// EXTERNAL MODULE: ./components/info-box-with-icon/info-box-with-icon.tsx
var info_box_with_icon = __webpack_require__(26022);
// EXTERNAL MODULE: ./lib/forms/formOptions.ts
var formOptions = __webpack_require__(73553);
// EXTERNAL MODULE: ./modules/files/hooks/use-file-uploader-with-form.tsx
var use_file_uploader_with_form = __webpack_require__(33510);
// EXTERNAL MODULE: ./lib/utils/file-size.ts
var file_size = __webpack_require__(93149);
// EXTERNAL MODULE: ./lib/utils/get-input-props.ts
var get_input_props = __webpack_require__(24018);
// EXTERNAL MODULE: ./modules/users/hooks/use-me.tsx
var use_me = __webpack_require__(17243);
// EXTERNAL MODULE: ./styles/colors.ts
var colors = __webpack_require__(32317);
// EXTERNAL MODULE: ./styles/media-query.ts
var media_query = __webpack_require__(97475);
// EXTERNAL MODULE: ./node_modules/baseui/esm/file-uploader/file-uploader.js + 9 modules
var file_uploader = __webpack_require__(47043);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 3 modules
var polished_esm = __webpack_require__(43281);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/styletron-react/dist-browser-esm/index.js
var dist_browser_esm = __webpack_require__(54511);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(50319);
// EXTERNAL MODULE: ./lib/graphql/documents.generated.ts
var documents_generated = __webpack_require__(60369);
// EXTERNAL MODULE: ./node_modules/lodash/compact.js
var compact = __webpack_require__(39693);
var compact_default = /*#__PURE__*/__webpack_require__.n(compact);
// EXTERNAL MODULE: ./pages/settings/inquiries/index.tsx
var inquiries = __webpack_require__(20989);
;// CONCATENATED MODULE: ./modules/inquiries/hooks/use-create-inquiry.tsx










var useCreateInquiry = function() {
    var me = (0,use_me/* useMe */.P)().me;
    var isLoggendIn = Boolean(me);
    // Form Context
    var ref = (0,index_esm/* useFormContext */.Gc)(), handleSubmit = ref.handleSubmit, setError = ref.setError;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(documents_generated/* CreateInquiryByMemberDocument */.ZX, {
        refetchQueries: [
            {
                query: documents_generated/* GetInquiriesByOffsetDocument */.Rv,
                variables: {
                    offset: 0,
                    limit: inquiries.INQUIRIES_PAGE_LIMIT,
                    sortBy: documents_generated/* InquirySortBy.CreatedAtDesc */.jG.CreatedAtDesc,
                    filter: {
                        questionerId: me === null || me === void 0 ? void 0 : me.id
                    }
                }
            }, 
        ]
    }), 1), createInquiryByMember = ref1[0];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(documents_generated/* CreateInquiryByNonMemberDocument */.XP), 1), createInquiryByNonMember = ref2[0];
    var onCreateInquiry = (0,react.useCallback)(function(input, done) {
        if (isLoggendIn) {
            createInquiryByMember({
                variables: {
                    input: input
                },
                onCompleted: function(data) {
                    done === null || done === void 0 ? void 0 : done(data.createInquiryByMember.id);
                }
            });
        } else {
            createInquiryByNonMember({
                variables: {
                    input: input
                },
                onCompleted: function() {
                    done === null || done === void 0 ? void 0 : done();
                }
            });
        }
    }, [
        createInquiryByMember,
        createInquiryByNonMember,
        isLoggendIn
    ]);
    var ref3 = (0,react.useState)(null), submitError = ref3[0], setSubmitError = ref3[1];
    var ref4 = (0,react.useState)(false), submitLoading = ref4[0], setSubmitLoading = ref4[1];
    var onSubmit = (0,react.useCallback)(function(done) {
        return handleSubmit(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                var question, email, title, files;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            question = param.question, email = param.email, title = param.title, files = param.files;
                            setSubmitError(null);
                            setSubmitLoading(true);
                            if (files && (files === null || files === void 0 ? void 0 : files.length) > 5) {
                                setError("files", {
                                    message: "파일은 최대 5개까지 업로드할 수 있습니다"
                                });
                            }
                            _ctx.prev = 4;
                            onCreateInquiry({
                                question: question,
                                email: email,
                                title: title,
                                files: compact_default()(files)
                            }, done);
                            _ctx.next = 12;
                            break;
                        case 8:
                            _ctx.prev = 8;
                            _ctx.t0 = _ctx["catch"](4);
                            console.error(_ctx.t0);
                            return _ctx.abrupt("return", setSubmitError("문의할 수 없습니다. 고객센터에 문의해주세요."));
                        case 12:
                            _ctx.prev = 12;
                            setSubmitLoading(false);
                            return _ctx.finish(12);
                        case 15:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        4,
                        8,
                        12,
                        15
                    ]
                ]);
            }));
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }());
    }, [
        handleSubmit,
        onCreateInquiry,
        setError
    ]);
    var onSubmitError = (0,react.useCallback)(function(err) {
        setSubmitError(err);
    }, []);
    return {
        onSubmit: onSubmit,
        submitError: submitError,
        submitLoading: submitLoading,
        onSubmitError: onSubmitError
    };
};

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./lib/utils/generate-path.ts
var generate_path = __webpack_require__(67134);
// EXTERNAL MODULE: ./lib/routes.ts
var routes = __webpack_require__(78954);
;// CONCATENATED MODULE: ./pages/support/inquiry/write.tsx

































var InquiryWritePage = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var methods = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            email: "",
            files: []
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(base_grid/* BaseGrid */.w, {
        spaceTop: [
            24,
            48,
            72
        ],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(base_cell/* BaseCell */.q, {
                span: [
                    4,
                    6,
                    8
                ],
                skip: [
                    0,
                    1,
                    0
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(heading/* HeadingM */.aw, {
                        children: "1대1 문의"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(heading/* HeadingS */.HR, {
                        color: colors/* colors.gray500 */.O.gray500,
                        marginTop: "24px",
                        children: "궁금한 내용이 있다면 언제든 연락해주세요."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(heading/* HeadingS */.HR, {
                        color: colors/* colors.gray500 */.O.gray500,
                        children: "최대 3영업일 이내에 답변 드리겠습니다."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormProvider */.RV, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, methods), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadForm, {})
                    }))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(base_cell/* BaseCell */.q, {
                span: [
                    4,
                    3,
                    3
                ],
                skip: [
                    0,
                    1,
                    1
                ],
                spaceTop: [
                    80,
                    80,
                    0
                ],
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(info_box_with_icon/* InfoBoxWithIcon */.R, {
                    icon: "Info",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* LabelM */.i_, {
                            weight: 700,
                            children: "운영시간"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(paragraph/* ParagraphS */.fw, {
                            whiteSpace: "pre-wrap",
                            marginTop: "8px",
                            children: "평일 10:00~19:00\n주말 및 공휴일 휴무"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(paragraph/* ParagraphS */.fw, {
                            marginTop: "16px",
                            color: colors/* colors.gray500 */.O.gray500,
                            whiteSpace: "pre-line",
                            children: "고객님의 문의에 대해서는 확인 후 답변 드리고 있으나 접수된 순서에 따라 답변이 진행되어 안내가 지연될 수 있는 점 참고 및 양해 부탁드립니다."
                        })
                    ]
                })
            })
        ]
    });
};
InquiryWritePage.getLayout = function(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(basic_layout/* BasicLayout */.i, {
        helmetTitle: "Ontol | 1대1 문의",
        children: page
    });
};
/* harmony default export */ var write = (InquiryWritePage);
var UploadForm = function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,dist_browser_esm/* useStyletron */.hQ)(), 1), css = ref7[0];
    var ref8 = (0,use_me/* useMe */.P)(), me = ref8.me, loading = ref8.loading;
    var router = (0,next_router.useRouter)();
    var ref9 = (0,react.useState)(null), inquiryId = ref9[0], setInquiryId = ref9[1];
    var ref10 = (0,react.useState)(false), confirmModal = ref10[0], setConfirmModal = ref10[1];
    var ref11 = (0,use_file_uploader_with_form/* useFileUploaderWithForm */.A)(), onDrop = ref11.onDrop, onDropRejected = ref11.onDropRejected, onRemoveFile = ref11.onRemoveFile;
    var ref12 = useCreateInquiry(), onSubmit = ref12.onSubmit, submitError = ref12.submitError, submitLoading = ref12.submitLoading, onSubmitError = ref12.onSubmitError;
    var ref13 = (0,index_esm/* useFormContext */.Gc)(), register = ref13.register, errors = ref13.formState.errors, control = ref13.control, watch = ref13.watch, handleSubmit = ref13.handleSubmit, resetField = ref13.resetField, setValue = ref13.setValue, clearErrors = ref13.clearErrors;
    var files = watch("files");
    (0,react.useEffect)(function() {
        if (!loading && me && me.email) {
            setValue("email", me.email);
        }
    }, [
        loading,
        me,
        setValue
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if (errors === null || errors === void 0 ? void 0 : (ref = errors.warning) === null || ref === void 0 ? void 0 : ref.message) {
            setTimeout(function() {
                clearErrors("warning");
            }, 3000);
        }
    }, [
        clearErrors,
        errors === null || errors === void 0 ? void 0 : (ref = errors.warning) === null || ref === void 0 ? void 0 : ref.message
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                className: css({
                    marginTop: "32px"
                }),
                onSubmit: handleSubmit(function() {
                    setConfirmModal(true);
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input_with_label/* BaseInputWithLabel */.w, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        label: "이메일",
                        placeholder: "example@gmail.com"
                    }, (0,get_input_props/* getInputProps */.T)(register("email", formOptions/* formOptions.EMAIL */.r.EMAIL))), {
                        error: (ref1 = errors.email) === null || ref1 === void 0 ? void 0 : ref1.message,
                        spaceTop: 16
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input_with_label/* BaseInputWithLabel */.w, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        label: "제목",
                        placeholder: "제목을 입력해주세요"
                    }, (0,get_input_props/* getInputProps */.T)(register("title", formOptions/* formOptions.TITLE */.r.TITLE))), {
                        error: (ref2 = errors.title) === null || ref2 === void 0 ? void 0 : ref2.message,
                        spaceTop: 16
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(base_block/* BaseBlock */.v, {
                        flexbox: true,
                        column: true,
                        position: "relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(base_textarea/* BaseTextarea */.d, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                spaceTop: 16,
                                placeholder: "내용을 입력해주세요"
                            }, (0,get_input_props/* getTextareaProps */.a)(register("question", {
                                required: "내용을 입력해주세요",
                                maxLength: {
                                    value: 2000,
                                    message: "내용은 2000자 이하로 입력해주세요"
                                }
                            }))), {
                                maxLength: 2000,
                                error: errors === null || errors === void 0 ? void 0 : (ref3 = errors.question) === null || ref3 === void 0 ? void 0 : ref3.message
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* LabelS */.ew, {
                                color: colors/* colors.gray500 */.O.gray500,
                                alignSelf: "flex-end",
                                marginTop: "8px",
                                children: "".concat(((ref4 = watch("question")) === null || ref4 === void 0 ? void 0 : ref4.length) || 0, "/2000")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(base_block/* BaseBlock */.v, {
                        flexbox: true,
                        marginTop: "24px",
                        alignItems: "center",
                        justifyContent: "space-between",
                        columnGap: "24px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* LabelXS */.Ei, {
                                color: colors/* colors.gray500 */.O.gray500,
                                children: "20MB 이하의 파일을 총 5개까지 첨부하실 수 있습니다"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                                name: "files",
                                control: control,
                                render: function() {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(file_uploader/* default */.Z, {
                                        accept: "image/*, application/pdf, application/zip, text/csv, application/vnd.ms-excel",
                                        maxSize: 1024 * 1024 * 20,
                                        onDrop: onDrop,
                                        onDropRejected: onDropRejected,
                                        overrides: {
                                            FileDragAndDrop: {
                                                style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,polished_esm/* borderStyle */.$u)("none"), (0,polished_esm/* padding */.o3)("0px")), {
                                                    backgroundColor: "transparent"
                                                })
                                            },
                                            ContentMessage: {
                                                component: function() {
                                                    return null;
                                                }
                                            },
                                            ButtonComponent: {
                                                component: function(props) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(base_button/* BaseButton */.Y, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                        $type: "tertiary",
                                                        $size: "s",
                                                        leading: "Attach",
                                                        type: "button"
                                                    }, props), {
                                                        overrides: {
                                                            BaseButton: {
                                                                style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,polished_esm/* margin */.e6)("0px")), {
                                                                    whiteSpace: "pre"
                                                                })
                                                            }
                                                        },
                                                        children: "파일 첨부"
                                                    }));
                                                }
                                            }
                                        }
                                    });
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(base_block/* BaseBlock */.v, {
                        flexbox: true,
                        columnGap: "16px",
                        rowGap: "8px",
                        flexWrap: true,
                        marginTop: "16px",
                        children: files && files.length > 0 && files.map(function(file) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(base_button/* BaseButton */.Y, {
                                    $size: "s",
                                    $type: "secondary",
                                    trailing: "Close",
                                    onClick: function() {
                                        return onRemoveFile(file.name);
                                    },
                                    children: [
                                        file.name,
                                        " (",
                                        (0,file_size/* fileSize */.j)(file.size),
                                        ")"
                                    ]
                                }, file.name)
                            }, file.name);
                        })
                    }),
                    (errors === null || errors === void 0 ? void 0 : (ref5 = errors.warning) === null || ref5 === void 0 ? void 0 : ref5.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* LabelS */.ew, {
                        marginTop: "16px",
                        color: colors/* colors.green300 */.O.green300,
                        children: errors.warning.message
                    }),
                    (errors === null || errors === void 0 ? void 0 : (ref6 = errors.files) === null || ref6 === void 0 ? void 0 : ref6.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* LabelS */.ew, {
                        marginTop: "16px",
                        color: colors/* colors.red400 */.O.red400,
                        children: errors.files.message
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(base_block/* BaseBlock */.v, {
                        flexbox: true,
                        flexCenter: true,
                        marginTop: "48px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base_button/* BaseButton */.Y, {
                            overrides: {
                                BaseButton: {
                                    style: (0,_define_property/* default */.Z)({
                                        width: "100%"
                                    }, media_query/* mediaQuery.TABLET */.c.TABLET, {
                                        width: "240px"
                                    })
                                }
                            },
                            type: "submit",
                            children: "문의하기"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_state_container/* ModalStateContainer */.L, {
                children: function(param) {
                    var isConfirmationOpen = param.isConfirmationOpen, toggleConfirm = param.toggleConfirm;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(confirm_modal/* ConfirmModal */.s, {
                                onClose: function() {
                                    setConfirmModal(false);
                                },
                                onConfirm: onSubmit(function(id) {
                                    toggleConfirm(true);
                                    if (id) {
                                        setInquiryId(id);
                                    }
                                }),
                                isOpen: confirmModal,
                                title: "작성한 내용을 제출하시겠습니까?",
                                description: "",
                                isLoading: submitLoading
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(alert_modal/* AlertModal */.V, {
                                onClose: function() {
                                    toggleConfirm(false);
                                    setConfirmModal(false);
                                    resetField("title");
                                    resetField("question");
                                    resetField("files");
                                    if (inquiryId) {
                                        router.push((0,generate_path/* generatePath */.G)(routes/* Routes.SETTINGS_INQUIRIES_DETAIL */.Z.SETTINGS_INQUIRIES_DETAIL, {
                                            id: inquiryId
                                        }));
                                    }
                                    if (!me) {
                                        resetField("email");
                                    }
                                },
                                isOpen: isConfirmationOpen,
                                title: "문의한 내용이 제출되었습니다.",
                                description: "최대 3영업일 이내에 답변 드리겠습니다.\n답변 내용은 이메일을 통해 확인하실 수 있습니다",
                                type: "success"
                            })
                        ]
                    });
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(alert_modal/* AlertModal */.V, {
                onClose: function() {
                    return onSubmitError(null);
                },
                isOpen: Boolean(submitError),
                title: "오류가 발생했습니다.",
                description: "1대1 문의 신청에 실패하였습니다."
            })
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7730,8116,4888,290,4627,3674,6030,7536,119,5438,6549,7210,5978,8843,2079,1319,8639,3692,989,9774,2888,179], function() { return __webpack_exec__(89529); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);